import React from 'react'
import { motion } from 'framer-motion'
import { FileText, Building2, User } from 'lucide-react'
import { useClient } from '../../contexts/ClientContext'

const stateOptions = [
    'ANDAMAN AND NICOBAR ISLANDS',
    'ANDHRA PRADESH',
    'ARUNACHAL PRADESH',
    'ASSAM',
    'BIHAR',
    'CHANDIGARH',
    'CHHATTISGARH',
    'DADRA & NAGAR HAVELI AND DAMAN & DIU',
    'DELHI',
    'GOA',
    'GUJARAT',
    'HARYANA',
    'HIMACHAL PRADESH',
    'JAMMU & KASHMIR',
    'JHARKHAND',
    'KARNATAKA',
    'KERALA',
    'LADAKH',
    'LAKSHWADEEP',
    'MADHYA PRADESH',
    'MAHARASHTRA',
    'MANIPUR',
    'MEGHALAYA',
    'MIZORAM',
    'NAGALAND',
    'ODISHA',
    'PONDICHERRY',
    'PUNJAB',
    'RAJASTHAN',
    'SIKKIM',
    'TAMIL NADU',
    'TELANGANA',
    'TRIPURA',
    'UTTAR PRADESH',
    'UTTARAKHAND',
    'WEST BENGAL'
];

const yesNoOptions = ['Yes', 'No'];

const countryCodeOptions = [
    { value: '91', label: '91 (India)' },
    { value: '1', label: '1 (USA / Canada)' },
    { value: '44', label: '44 (United Kingdom)' },
    { value: '971', label: '971 (UAE)' },
    { value: '65', label: '65 (Singapore)' },
    { value: '61', label: '61 (Australia)' },
    { value: '49', label: '49 (Germany)' },
    { value: '33', label: '33 (France)' },
    { value: '81', label: '81 (Japan)' },
    { value: '86', label: '86 (China)' },
    { value: '966', label: '966 (Saudi Arabia)' },
    { value: '974', label: '974 (Qatar)' },
    { value: '968', label: '968 (Oman)' },
    { value: '965', label: '965 (Kuwait)' },
    { value: '973', label: '973 (Bahrain)' },
    { value: '977', label: '977 (Nepal)' },
    { value: '94', label: '94 (Sri Lanka)' },
    { value: '880', label: '880 (Bangladesh)' },
    { value: '92', label: '92 (Pakistan)' },
    { value: '60', label: '60 (Malaysia)' },
    { value: '62', label: '62 (Indonesia)' },
    { value: '63', label: '63 (Philippines)' },
    { value: '66', label: '66 (Thailand)' },
    { value: '84', label: '84 (Vietnam)' },
    { value: '82', label: '82 (South Korea)' },
    { value: '7', label: '7 (Russia)' },
    { value: '39', label: '39 (Italy)' },
    { value: '34', label: '34 (Spain)' },
    { value: '31', label: '31 (Netherlands)' },
    { value: '41', label: '41 (Switzerland)' },
    { value: '46', label: '46 (Sweden)' },
    { value: '47', label: '47 (Norway)' },
    { value: '45', label: '45 (Denmark)' },
    { value: '358', label: '358 (Finland)' },
    { value: '353', label: '353 (Ireland)' },
    { value: '64', label: '64 (New Zealand)' },
    { value: '27', label: '27 (South Africa)' },
    { value: '55', label: '55 (Brazil)' },
    { value: '52', label: '52 (Mexico)' },
    { value: '20', label: '20 (Egypt)' },
    { value: '90', label: '90 (Turkey)' },
    { value: '972', label: '972 (Israel)' },
    { value: '48', label: '48 (Poland)' },
    { value: '30', label: '30 (Greece)' },
    { value: '351', label: '351 (Portugal)' },
    { value: '43', label: '43 (Austria)' },
    { value: '32', label: '32 (Belgium)' },
    { value: '420', label: '420 (Czech Republic)' },
    { value: '36', label: '36 (Hungary)' },
    { value: '40', label: '40 (Romania)' },
    { value: '380', label: '380 (Ukraine)' },
    { value: '852', label: '852 (Hong Kong)' },
    { value: '886', label: '886 (Taiwan)' },
    { value: '234', label: '234 (Nigeria)' },
    { value: '254', label: '254 (Kenya)' },
    { value: '233', label: '233 (Ghana)' },
    { value: '251', label: '251 (Ethiopia)' },
    { value: '54', label: '54 (Argentina)' },
    { value: '56', label: '56 (Chile)' },
    { value: '57', label: '57 (Colombia)' },
    { value: '51', label: '51 (Peru)' },
    { value: '58', label: '58 (Venezuela)' },
    { value: '962', label: '962 (Jordan)' },
    { value: '961', label: '961 (Lebanon)' },
    { value: '964', label: '964 (Iraq)' },
    { value: '98', label: '98 (Iran)' },
    { value: '93', label: '93 (Afghanistan)' },
    { value: '95', label: '95 (Myanmar)' },
    { value: '855', label: '855 (Cambodia)' },
    { value: '856', label: '856 (Laos)' },
    { value: '976', label: '976 (Mongolia)' },
    { value: '994', label: '994 (Azerbaijan)' },
    { value: '995', label: '995 (Georgia)' },
    { value: '374', label: '374 (Armenia)' },
    { value: '998', label: '998 (Uzbekistan)' },
    { value: '996', label: '996 (Kyrgyzstan)' },
    { value: '992', label: '992 (Tajikistan)' },
    { value: '993', label: '993 (Turkmenistan)' },
    { value: '212', label: '212 (Morocco)' },
    { value: '213', label: '213 (Algeria)' },
    { value: '216', label: '216 (Tunisia)' },
    { value: '255', label: '255 (Tanzania)' },
    { value: '256', label: '256 (Uganda)' },
    { value: '260', label: '260 (Zambia)' },
    { value: '263', label: '263 (Zimbabwe)' },
    { value: '230', label: '230 (Mauritius)' },
    { value: '248', label: '248 (Seychelles)' }
];

const TdsProfileSection = ({
    profileData,
    isProfileEditing,
    onProfileDataChange,
    handleProfileInputChange: propHandleProfileInputChange,
    onPrefillClick,
    selectedReturnType
}) => {
    const { activeClient } = useClient();
    const handleProfileInputChange = onProfileDataChange || propHandleProfileInputChange;

    return (
        <div className="space-y-6">
            {/* Profile Header */}
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">
                        Profile Details
                    </h2>
                </div>
            </div>

            {/* Section 1: Particulars of Statement */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="bg-white rounded-lg shadow-md p-6 overflow-visible"
            >
                <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center">
                        <FileText className="w-6 h-6 text-blue-600 mr-3" />
                        <h3 className="text-xl font-semibold text-gray-900 break-words">1. Particulars of Statement</h3>
                    </div>
                    {isProfileEditing && (
                        <button
                            type="button"
                            onClick={onPrefillClick}
                            className="text-sm bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-md shadow-md transition-colors flex items-center gap-2"
                        >
                            <User className="w-4 h-4" />
                            Pre-fill Profile Data
                        </button>
                    )}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div className="break-words">
                        <div className="flex justify-between items-center mb-2">
                            <label className="block text-sm font-medium text-gray-700 break-words">
                                Tax Deduction <span className="text-red-500">*</span>
                            </label>
                        </div>
                        {isProfileEditing ? (
                            <input
                                type="text"
                                value={profileData?.section1?.taxDeduction || ''}
                                onChange={(e) => handleProfileInputChange('section1.taxDeduction', e.target.value)}
                                required
                                className="w-full px-3 py-2 border-2 border-blue-300 bg-blue-50 focus:ring-blue-500 focus:border-blue-500 rounded-md focus:outline-none focus:ring-2 text-gray-900"
                                placeholder="Enter Tax Deduction"
                            />
                        ) : (
                            <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section1?.taxDeduction || 'Not provided'}</p>
                        )}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 break-words">
                            Permanent Account Number <span className="text-red-500">*</span>
                        </label>
                        {isProfileEditing ? (
                            <input
                                type="text"
                                value={profileData?.section1?.permanentAccountNumber || ''}
                                onChange={(e) => handleProfileInputChange('section1.permanentAccountNumber', e.target.value)}
                                required
                                className="w-full px-3 py-2 border-2 border-blue-300 bg-blue-50 focus:ring-blue-500 focus:border-blue-500 rounded-md focus:outline-none focus:ring-2 text-gray-900"
                                placeholder="Enter PAN"
                                maxLength="10"
                            />
                        ) : (
                            <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section1?.permanentAccountNumber || 'Not provided'}</p>
                        )}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 break-words">
                            Type of Deductor <span className="text-red-500">*</span>
                        </label>
                        {isProfileEditing ? (
                            <select
                                value={profileData?.section1?.typeOfDeduction || ''}
                                onChange={(e) => handleProfileInputChange('section1.typeOfDeduction', e.target.value)}
                                required
                                className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                            >
                                <option value="">Select Type</option>
                                <option value="A">Central Government (A)</option>
                                <option value="S">State Government (S)</option>
                                <option value="D">Statutory body (Central Govt.) (D)</option>
                                <option value="E">Statutory body (State Govt.) (E)</option>
                                <option value="G">Autonomous body (Central Govt.) (G)</option>
                                <option value="H">Autonomous body (State Govt.) (H)</option>
                                <option value="L">Local Authority (Central Govt.) (L)</option>
                                <option value="N">Local Authority (State Govt.) (N)</option>
                                <option value="K">Company (K)</option>
                                <option value="M">Branch / Division of Company (M)</option>
                                <option value="P">Association of Person (AOP) (P)</option>
                                <option value="T">Association of Person (Trust) (T)</option>
                                <option value="J">Artificial Juridical Person (J)</option>
                                <option value="B">Body of Individuals (B)</option>
                                <option value="Q">Individual/HUF (Q)</option>
                                <option value="F">Firm (F)</option>
                            </select>
                        ) : (
                            <p className="text-lg font-semibold text-gray-900 break-words">
                                {(() => {
                                    const val = profileData?.section1?.typeOfDeduction;
                                    const map = {
                                        'A': 'Central Government', 'S': 'State Government',
                                        'D': 'Statutory body (Central)', 'E': 'Statutory body (State)',
                                        'G': 'Autonomous body (Central)', 'H': 'Autonomous body (State)',
                                        'L': 'Local Authority (Central)', 'N': 'Local Authority (State)',
                                        'K': 'Company', 'M': 'Branch / Division of Company',
                                        'P': 'Association of Person (AOP)', 'T': 'Association of Person (Trust)',
                                        'J': 'Artificial Juridical Person', 'B': 'Body of Individuals',
                                        'Q': 'Individual/HUF', 'F': 'Firm'
                                    };
                                    return val ? `${map[val] || val} (${val})` : 'Not provided';
                                })()}
                            </p>
                        )}
                    </div>
                </div>
            </motion.div>

            {/* Section 2: Particulars of Deductor (Employer) */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                className="bg-white rounded-lg shadow-md p-6 overflow-visible"
            >
                <div className="flex items-center mb-6">
                    <Building2 className="w-6 h-6 text-green-600 mr-3" />
                    <h3 className="text-xl font-semibold text-gray-900 break-words">2. Particulars of Deductor (Employer)</h3>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 break-words">
                    {/* Left Column */}
                    <div className="space-y-6 break-words min-w-0">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Name <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section2?.name}
                                    onChange={(e) => handleProfileInputChange('section2.name', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 bg-blue-50 focus:ring-blue-500 focus:border-blue-500 rounded-md focus:outline-none focus:ring-2 text-gray-900"
                                    placeholder="Enter Name"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.name || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2 break-words">
                                Branch / Division <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section2?.branchDivision}
                                    onChange={(e) => handleProfileInputChange('section2.branchDivision', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Branch/Division"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.branchDivision || 'Not provided'}</p>
                            )}
                        </div>


                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Name of Premises / Building <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section2?.nameOfPremises}
                                    onChange={(e) => handleProfileInputChange('section2.nameOfPremises', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Name of Premises/Building"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.nameOfPremises || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Area / Location <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section2?.areaLocality}
                                    onChange={(e) => handleProfileInputChange('section2.areaLocality', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Area/Location"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.areaLocality || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                PIN Code <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section2?.pinCode}
                                    onChange={(e) => handleProfileInputChange('section2.pinCode', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter PIN Code"
                                    maxLength="6"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.pinCode || 'Not provided'}</p>
                            )}
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="space-y-6 break-words min-w-0">

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Flat No. <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section2?.flatNo}
                                    onChange={(e) => handleProfileInputChange('section2.flatNo', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Flat No."
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.flatNo || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Road / Street / Lane <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section2?.roadStreet}
                                    onChange={(e) => handleProfileInputChange('section2.roadStreet', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Road/Street/Lane"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.roadStreet || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Town / City / District <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section2?.townCity}
                                    onChange={(e) => handleProfileInputChange('section2.townCity', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Town/City/District"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.townCity || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                State <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <select
                                    value={profileData?.section2?.state}
                                    onChange={(e) => handleProfileInputChange('section2.state', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                >
                                    <option value="">--Select--</option>
                                    {stateOptions.map(state => (
                                        <option key={state} value={state}>{state}</option>
                                    ))}
                                </select>
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.state || 'Not selected'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                E-mail <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="email"
                                    value={profileData?.section2?.email}
                                    onChange={(e) => handleProfileInputChange('section2.email', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Email"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.email || 'Not provided'}</p>
                            )}
                        </div>

                        <div className="flex items-start gap-4">
                            <div className="w-36">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    STD Code <span className="text-red-500">*</span>
                                </label>
                                {isProfileEditing ? (
                                    <select
                                        value={profileData?.section2?.stdCode || '91'}
                                        onChange={(e) => handleProfileInputChange('section2.stdCode', e.target.value)}
                                        required
                                        className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    >
                                        <option value="">--Select--</option>
                                        {profileData?.section2?.stdCode && !countryCodeOptions.some(o => o.value === String(profileData.section2.stdCode)) && (
                                            <option value={profileData.section2.stdCode}>{profileData.section2.stdCode}</option>
                                        )}
                                        {countryCodeOptions.map(opt => (
                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.stdCode || 'Not provided'}</p>
                                )}
                            </div>

                            <div className="flex-1">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Telephone No <span className="text-red-500">*</span>
                                </label>
                                {isProfileEditing ? (
                                    <input
                                        type="text"
                                        value={profileData?.section2?.telephoneNo}
                                        onChange={(e) => handleProfileInputChange('section2.telephoneNo', e.target.value)}
                                        required
                                        className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                        placeholder="Enter Telephone No"
                                    />
                                ) : (
                                    <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section2?.telephoneNo || 'Not provided'}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>

            {/* Section 3: Particulars of the Person Responsible for Deduction of Tax */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="bg-white rounded-lg shadow-md p-6 overflow-visible"
            >
                <div className="flex items-center mb-6">
                    <User className="w-6 h-6 text-purple-600 mr-3" />
                    <h3 className="text-xl font-semibold text-gray-900 break-words">3. Particulars of the Person Responsible for Deduction of Tax</h3>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 break-words">
                    {/* Left Column */}
                    <div className="space-y-6 break-words min-w-0">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Name <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section3?.name}
                                    onChange={(e) => handleProfileInputChange('section3.name', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Name"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section3?.name || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Designation <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section3?.designation}
                                    onChange={(e) => handleProfileInputChange('section3.designation', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Designation"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section3?.designation || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Name of Premises / Building <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section3?.sameAsAbove ? (profileData?.section2?.nameOfPremises || '') : (profileData?.section3?.nameOfPremises || '')}
                                    onChange={(e) => handleProfileInputChange('section3.nameOfPremises', e.target.value)}
                                    disabled={profileData?.section3?.sameAsAbove || false}
                                    required={!profileData?.section3?.sameAsAbove}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900 disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed"
                                    placeholder="Enter Name of Premises/Building"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{(profileData?.section3?.sameAsAbove ? profileData?.section2?.nameOfPremises : profileData?.section3?.nameOfPremises) || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Area / Location <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section3?.sameAsAbove ? (profileData?.section2?.areaLocality || '') : (profileData?.section3?.areaLocality || '')}
                                    onChange={(e) => handleProfileInputChange('section3.areaLocality', e.target.value)}
                                    disabled={profileData?.section3?.sameAsAbove || false}
                                    required={!profileData?.section3?.sameAsAbove}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900 disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed"
                                    placeholder="Enter Area/Location"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{(profileData?.section3?.sameAsAbove ? profileData?.section2?.areaLocality : profileData?.section3?.areaLocality) || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                PIN Code <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section3?.sameAsAbove ? (profileData?.section2?.pinCode || '') : (profileData?.section3?.pinCode || '')}
                                    onChange={(e) => handleProfileInputChange('section3.pinCode', e.target.value)}
                                    disabled={profileData?.section3?.sameAsAbove || false}
                                    required={!profileData?.section3?.sameAsAbove}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900 disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed"
                                    placeholder="Enter PIN Code"
                                    maxLength="6"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{(profileData?.section3?.sameAsAbove ? profileData?.section2?.pinCode : profileData?.section3?.pinCode) || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Telephone No. <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <div className="flex space-x-2">
                                    <select
                                        value={(profileData?.section3?.sameAsAbove ? profileData?.section2?.stdCode : profileData?.section3?.stdCode) || '91'}
                                        onChange={(e) => handleProfileInputChange('section3.stdCode', e.target.value)}
                                        disabled={profileData?.section3?.sameAsAbove || false}
                                        required={!profileData?.section3?.sameAsAbove}
                                        className="w-36 px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900 disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed"
                                    >
                                        <option value="">Code</option>
                                        {countryCodeOptions.map(opt => (
                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select>
                                    <input
                                        type="text"
                                        value={profileData?.section3?.sameAsAbove ? (profileData?.section2?.telephoneNo || '') : (profileData?.section3?.telephone || '')}
                                        onChange={(e) => handleProfileInputChange('section3.telephone', e.target.value)}
                                        disabled={profileData?.section3?.sameAsAbove || false}
                                        required={!profileData?.section3?.sameAsAbove}
                                        className="flex-1 px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900 disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed"
                                        placeholder="Enter Telephone Number"
                                    />
                                </div>
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">
                                    {(profileData?.section3?.sameAsAbove ? profileData?.section2?.stdCode : profileData?.section3?.stdCode) ? `${profileData?.section3?.sameAsAbove ? profileData?.section2?.stdCode : profileData?.section3?.stdCode} - ` : ''}
                                    {(profileData?.section3?.sameAsAbove ? profileData?.section2?.telephoneNo : profileData?.section3?.telephone) || 'Not provided'}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Telephone No. (Alternate)
                            </label>
                            {isProfileEditing ? (
                                <div className="flex space-x-2">
                                    <input
                                        type="text"
                                        placeholder="Area Code"
                                        value={profileData?.section3?.stdCodeAlternate || ''}
                                        onChange={(e) => handleProfileInputChange('section3.stdCodeAlternate', e.target.value)}
                                        className="w-20 px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    />
                                    <input
                                        type="text"
                                        value={profileData?.section3?.telephoneAlternate}
                                        onChange={(e) => handleProfileInputChange('section3.telephoneAlternate', e.target.value)}
                                        className="flex-1 px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                        placeholder="Enter Alternate Telephone Number"
                                    />
                                </div>
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">
                                    {profileData?.section3?.stdCodeAlternate ? `${profileData.section3.stdCodeAlternate} - ` : ''}
                                    {profileData?.section3?.telephoneAlternate || 'Not provided'}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Has Address Changed Since Last Return <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <select
                                    value={profileData?.section3?.hasAddressChanged}
                                    onChange={(e) => handleProfileInputChange('section3.hasAddressChanged', e.target.value)}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                >
                                    <option value="">--Select--</option>
                                    {yesNoOptions.map(option => (
                                        <option key={option} value={option}>{option}</option>
                                    ))}
                                </select>
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section3?.hasAddressChanged || 'Not selected'}</p>
                            )}
                        </div>


                    </div>

                    {/* Right Column */}
                    <div className="space-y-6 break-words min-w-0">
                        <div className="h-[74px] flex items-center">
                            {isProfileEditing ? (
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        checked={profileData?.section3?.sameAsAbove || false}
                                        onChange={(e) => handleProfileInputChange('section3.sameAsAbove', e.target.checked)}
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                                    />
                                    <span className="ml-2 text-sm text-gray-700">Check if same as above</span>
                                </div>
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">
                                    {profileData?.section3?.sameAsAbove ? 'Yes' : 'No'}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Permanent Account Number <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section3?.permanentAccountNumber}
                                    onChange={(e) => handleProfileInputChange('section3.permanentAccountNumber', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter PAN"
                                    maxLength="10"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section3?.permanentAccountNumber || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Flat No. <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section3?.sameAsAbove ? (profileData?.section2?.flatNo || '') : (profileData?.section3?.flatNo || '')}
                                    onChange={(e) => handleProfileInputChange('section3.flatNo', e.target.value)}
                                    disabled={profileData?.section3?.sameAsAbove || false}
                                    required={!profileData?.section3?.sameAsAbove}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900 disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed"
                                    placeholder="Enter Flat No."
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{(profileData?.section3?.sameAsAbove ? profileData?.section2?.flatNo : profileData?.section3?.flatNo) || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Road / Street / Lane <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section3?.sameAsAbove ? (profileData?.section2?.roadStreet || '') : (profileData?.section3?.roadStreet || '')}
                                    onChange={(e) => handleProfileInputChange('section3.roadStreet', e.target.value)}
                                    disabled={profileData?.section3?.sameAsAbove || false}
                                    required={!profileData?.section3?.sameAsAbove}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900 disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed"
                                    placeholder="Enter Road/Street/Lane"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{(profileData?.section3?.sameAsAbove ? profileData?.section2?.roadStreet : profileData?.section3?.roadStreet) || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Town / City / District <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="text"
                                    value={profileData?.section3?.sameAsAbove ? (profileData?.section2?.townCity || '') : (profileData?.section3?.townCity || '')}
                                    onChange={(e) => handleProfileInputChange('section3.townCity', e.target.value)}
                                    disabled={profileData?.section3?.sameAsAbove || false}
                                    required={!profileData?.section3?.sameAsAbove}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900 disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed"
                                    placeholder="Enter Town/City/District"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{(profileData?.section3?.sameAsAbove ? profileData?.section2?.townCity : profileData?.section3?.townCity) || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                State <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <select
                                    value={profileData?.section3?.sameAsAbove ? (profileData?.section2?.state || '') : (profileData?.section3?.state || '')}
                                    onChange={(e) => handleProfileInputChange('section3.state', e.target.value)}
                                    disabled={profileData?.section3?.sameAsAbove || false}
                                    required={!profileData?.section3?.sameAsAbove}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900 disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed"
                                >
                                    <option value="">--Select--</option>
                                    {stateOptions.map(state => (
                                        <option key={state} value={state}>{state}</option>
                                    ))}
                                </select>
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{(profileData?.section3?.sameAsAbove ? profileData?.section2?.state : profileData?.section3?.state) || 'Not selected'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                E-mail <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="email"
                                    value={profileData?.section3?.sameAsAbove ? (profileData?.section2?.email || '') : (profileData?.section3?.email || '')}
                                    onChange={(e) => handleProfileInputChange('section3.email', e.target.value)}
                                    disabled={profileData?.section3?.sameAsAbove || false}
                                    required={!profileData?.section3?.sameAsAbove}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900 disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed"
                                    placeholder="Enter Email"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{(profileData?.section3?.sameAsAbove ? profileData?.section2?.email : profileData?.section3?.email) || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                E-mail (Alternate)
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="email"
                                    value={profileData?.section3?.emailAlternate}
                                    onChange={(e) => handleProfileInputChange('section3.emailAlternate', e.target.value)}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Alternate Email"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section3?.emailAlternate || 'Not provided'}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Mobile No. <span className="text-red-500">*</span>
                            </label>
                            {isProfileEditing ? (
                                <input
                                    type="tel"
                                    value={profileData?.section3?.mobileNo}
                                    onChange={(e) => handleProfileInputChange('section3.mobileNo', e.target.value)}
                                    required
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                    placeholder="Enter Mobile Number"
                                />
                            ) : (
                                <p className="text-lg font-semibold text-gray-900 break-words">{profileData?.section3?.mobileNo || 'Not provided'}</p>
                            )}
                        </div>
                    </div>
                </div>
            </motion.div>
        </div>
    )
}

export default TdsProfileSection
